export default __webpack_public_path__ + "static/media/next-earbuddyzpro.9a79574c.jpg";